import { Component, OnInit, ChangeDetectorRef, ApplicationRef, ViewChild} from '@angular/core';
import { BaseService } from '../../../services/base.services';
import {NgbDate, NgbCalendar, NgbDateParserFormatter, NgbTabsetConfig} from '@ng-bootstrap/ng-bootstrap';
import pageSettings from '../../../config/page-settings';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { formatDate} from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material';
import { DaterangepickerComponent, DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { NgxChartsModule, id } from '@swimlane/ngx-charts';
import * as moment from 'moment';
import 'nvd3';
declare var Highcharts: any;
declare var nv: any;
import * as global from '../../../config/globals';
@Component({
  selector: 'pagecheck',
  templateUrl: './page-check.html',
  styleUrls: ['page-check.css']
})

export class PageCheck implements OnInit{
  private data:Array<any> = [];
  pageSettings = pageSettings;
  finish = false;
  todaySurvey = false;
  country = 'chile';
  final = false;
  listTodaySurvey = false;
  nombre;
  apellido;
  email;
  direccion;
  empresa;
  oficina;
  responseForm;
  warning;
  dataUser;
  currentOffice = 1;
  currentCompany = 1;
  otraEmpresa = false;
  otraOficina = false;
  otraEnfermedad = false;
  edad;
  show = true;
  show2 = true;
  paso1= false;
  paso2= false;
  paso3= false;
  loading = false;
  encuesta: any;
  solicitud:any = {};
  mostrarDeclaracion = false;
  mostrarEstado = false;
  nombres;
  apellidos;
  telefono;
  hash;
  datosEncuestadosLocal;
  declaracion = false;
  sinRiesgo = false;
  storage;
  solicitudSeleccionada:any = {};
  emailIncorrecto = false;
  inhabilitarCampo = false;
  esAdministrador = false;
  empresaSeleccionada = 1;
  areaSeleccionada = 1;
  finalEstado = false;
  ocultarChart = false;
  listEmpresas: any = [];
  listArea: any = [];
  listEstadosSolicitudPersonal:any = [];
  fechaInicio: any;
  horaInicio: any;
  fechaFin:any;
  horaFin:any;
  motivo: any;
  rut: any;
  total = 0;
  aprobadas = 0;
  rechazadas = 0;
  listSolicitudes:any = [];
  listSolicitudesFilter:any = [];
  listVisitas:any = [];
  listNuevasPersonas = [];
  disableRut= false;
  listPersonasVisitantes = []
  urlAdministrador = false;
  rangoFechaInicio: any;
  rangoFechaFin:any;
  buscar;
  buscarSolicitud;
    /* Daterangepicker */
    rangoFecha: {startDate: moment.Moment, endDate: moment.Moment};
    @ViewChild(DaterangepickerDirective, {static: true}) pickerDirective: DaterangepickerDirective;
    inlineDate: any;
    inlineDateTime: any;
    picker: DaterangepickerComponent;
    alwaysShowCalendars: boolean;
    showRangeLabelOnInput: boolean;
    keepCalendarOpeningWithRange: boolean;
    prevDate: any = moment().subtract('days', 15).format('D MMMM') + ' - ' + moment().subtract('days', 8).format('D MMMM YYYY');
    ranges: any = {
      'Hoy': [moment(), moment()],
      //'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      '7 días': [moment().subtract(6, 'days'), moment()],
      '30 días': [moment().subtract(29, 'days'), moment()],
      //'This Month': [moment().startOf('month'), moment().endOf('month')],
      'Mes pasado': [
        moment()
          .subtract(1, 'month')
          .startOf('month'),
        moment()
          .subtract(1, 'month')
          .endOf('month')
      ]
    };
    locale: any = {
      format: 'D MMMM YYYY',
      displayFormat: 'D MMMM YYYY',
      separator: ' - ',
      cancelLabel: 'Cancelar',
      applyLabel: 'Aceptar',
      clearLabel: 'Limpiar'
    }
  

    multi: any[];
    view: any[] = [700, 400];
  
    // options
    showXAxis: boolean = true;
    showYAxis: boolean = true;
    gradient: boolean = true;
    showLegend: boolean = true;
    showXAxisLabel: boolean = true;
    xAxisLabel: string = 'Country';
    showYAxisLabel: boolean = true;
    yAxisLabel: string = 'Population';
    legendTitle: string = 'Years';
  
    colorScheme = {
      domain: ['#5AA454', '#C7B42C', '#AAAAAA']
    };

    administrador: any;
    listEncontrados: any = [];
    codigo;
    noHayCupo = false;
  public constructor(
    private baseService: BaseService,
    private calendar: NgbCalendar, 
    public formatter: NgbDateParserFormatter,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private _formBuilder: FormBuilder,
    private router: Router,
    private cd : ChangeDetectorRef,
    private route: ActivatedRoute,
    private appRef: ApplicationRef,
    private config: NgbTabsetConfig
    ) {

      this.pageSettings.pageEmpty = true;
      config.justify = 'center';
      //config.type = 'pills';
      this.country = this.route.snapshot.paramMap.get('codigo') == null ? 'chile' : this.route.snapshot.paramMap.get('codigo');

  }

  async ngOnInit()  {
    //this.getEncuesta();
    //this.getDatosEncuestado();
    

    await this.route.params.subscribe( async  params =>{
      if(params['rut']) {
          this.rut = params['rut'];
          var body = {
            Division: 'DCH',
            Validador: this.rut,
            Captcha: 0
          }
          console.log(params['rut']);
          this.getLogin(body);
        }
        
      });
    this.paso1 = true;
  }

  
  async getUser(rut){
    var body = {
      Division: 'DCH',
      Validador: rut,
      Captcha: 0
    }
    var response : any = await this.baseService.sp_Login(body).toPromise();
    if(response.length > 0){
      this.rut = response[0].rut;
      this.nombres = response[0].nombres;
      this.apellidos = response[0].apellidos;
      this.email = response[0].email;
      this.telefono = response[0].telefono;
    }else{
      this.rut = rut;
      this.nombres = '';
      this.apellidos = '';
      this.email = '';
      this.telefono = '';
    }
  }


  validar1(){
    console.log(this.fechaFin);
    if(!this.motivo){
      this.toastr.error('Llene todos los campos', '');
      return;
    }
    this.paso1 = false;
    this.paso2 = true;
  }


  async validar2(){
    if(this.listNuevasPersonas.length == 0){
      this.toastr.error('Ingrese al menos sus datos de usuario', '');
      return;
    }
    await this.guardarSolicitud();

  }


  setDatosUsuarios(data){
    this.rut = data.rut;
    this.nombres = data.nombres;
    this.apellidos = data.apellidos;
    this.email = data.email;
    this.telefono = data.telefono;
  }



  async guardarSolicitud(){

    var body1 ={
      nombres: this.nombres, 
      apellidos: this.apellidos,
      email	: this.email,
      telefono: this.telefono,
      idEmpresa: this.empresaSeleccionada,
      empresa: this.solicitud.empresa,
      rut: this.rut
    }

    var personal : any = await this.baseService.add_Personal(body1).toPromise();

    var solicitudPersonal : any = await this.baseService.add_SolicitudPersonal({
      idSolicitud: this.solicitud.idSolicitud, 
      idPersonal	: personal[0].idPersonal, 
      esPrincipal:  0
    }).toPromise();

    var data2 = {
      email: this.email, 
      tipo: 'Enviada',
      empresa: this.solicitud.empresaSolicitud,
      area:  this.solicitud.idArea,
      fecha: 'Desde el '+ this.solicitud.fechaInicio + ' hasta el ' + this.solicitud.fechaFin,
      nombre: this.nombres + ' ' + this.apellidos,
      idSolicitud: this.solicitud.idSolicitud,
      idPersonal: personal[0].idPersonal,
    }

    await this.baseService.enviar_email(data2).toPromise();
    
    this.mostrarDeclaracion = true; 
    this.paso3 = false; 
    this.esAdministrador=false;
    this.toastr.success('Su solicitud se ha enviado satisfactoriamente', '');
  }
  


  async getSolicitudesPersona(data){
    try {
      var response:any = await this.baseService.get_SolicitudesPersona(data).toPromise();
      if(response.length > 0){ 
        this.mostrarEstado = true;
        this.paso1 = false;
        this.solicitud = response[0];
      }

    }catch(error) {
      console.log(error);
    }
  }

  async set_estado_solicitud_personal(data){
    try {
      var response:any = await this.baseService.set_estado_solicitud_personal(data).toPromise();
      console.log(response);
      this.toastr.success('El estado de la solicitud ha sido modificado','');
    }catch(error) {
      console.log(error);
    }
  }

  async get_EstadoSolicitud(){
    try {
      var response:any = await this.baseService.get_EstadoSolicitud().toPromise();
      this.listEstadosSolicitudPersonal = response;
    }catch(error) {
      console.log(error);
    }
  }

  async setEstadoPersonal(idSolicitud, idPersonal, estado){
    var data = {idSolicitud: idSolicitud, idPersonal: idPersonal, idEstado: estado};
    await this.set_estado_solicitud_personal(data);
    if(!this.esAdministrador){      
      this.reset();
      if(estado == 5){
        this.mostrarEstado = false;
      }
    }
  }

  reset(){
    var body = {
      Division: 'DCH',
      Validador: this.storage.Validador,
      Captcha: 0
    }
    this.mostrarDeclaracion = false;
    this.getLogin(body);
  }
  
  async getLogin(body){
    try{
      var response : any = await this.baseService.sp_Login(body).toPromise();
      if(response.length > 0){   
        this.getSolicitudesPersona({idPersonal: response[0].idPersonal});
        this.setDatosUsuarios(response[0]);
      }

    }catch(error){
      console.log(error);
    }    
  }

  async save() {
    if(!this.rut || !this.nombres || !this.apellidos || !this.email){
      this.toastr.error('Por favor llenar todos los campos', '');
      
      return;
    }

    if(!this.validateEmail()) {
      this.toastr.error('Ingrese correctamente el email', '');
      return;
    }
    var data = {idSolicitud: this.codigo};
    var response: any = await this.baseService.get_SolicitudesPersonal(data).toPromise();    
    var solicitudesFiltradas = response.filter(x=> x.rut !== this.rut);
    console.log(response);
    if(response.length !== solicitudesFiltradas.length){
      this.toastr.error('El rut ya se encuentra registrado', '');
      return;
    }
    try{
      var cantidad : any = await this.baseService.get_NumPendientesSolicitud(data).toPromise();
      if(cantidad.length > 0){
        if(cantidad[0].Cupos < 1){
          this.noHayCupo = true;
          this.toastr.error('La solicitud grupal ya no poseé mas cupos, por favor ingrese una nueva solicitud', '');
          return;
        }
      }
      var body1 = {
        nombres: this.nombres, 
        apellidos: this.apellidos,
        email	: this.email,
        telefono: this.telefono,
        idEmpresa: this.empresaSeleccionada,
        empresa: this.solicitud.empresa,
        rut: this.rut
      }
  
      var personal : any = await this.baseService.add_Personal(body1).toPromise();
  
      var solicitudPersonal : any = await this.baseService.add_SolicitudPersonal({
        idSolicitud: this.solicitud.idSolicitud, 
        idPersonal	: personal[0].idPersonal, 
        esPrincipal:  0
      }).toPromise();
  
      var data2 = {
        email: this.email, 
        tipo: 'Enviada',
        empresa: this.solicitud.empresaSolicitud,
        area:  this.solicitud.idArea,
        fecha: 'Desde el '+ this.solicitud.fechaInicio + ' hasta el ' + this.solicitud.fechaFin,
        nombre: this.nombres + ' ' + this.apellidos,
        idSolicitud: this.solicitud.idSolicitud,
        idPersonal: personal[0].idPersonal,
      }
  
      await this.baseService.enviar_email(data2).toPromise();
      this.toastr.success('Su solicitud se ha enviado satisfactoriamente', '');

    }catch(error){
      console.log(error);
    }    
  }


  async add_Resultado(data){
    try{
      var response: any = await this.baseService.add_Resultado(data).toPromise();
      console.log(response);
      return response;
    }catch(error){
      console.log(error);
    }    
  }

  async enviar_email(data){
    try{

      var response: any = await this.baseService.enviar_email(data).toPromise();
      console.log(response);
      return response;
    }catch(error){
      console.log(error);
    }    
  }
  async add_Solicitud(data){
    try{
      var response: any = await this.baseService.add_Solicitud(data).toPromise();
      console.log(response);
      return response;
    }catch(error){
      console.log(error);
    }    
  }

  async add_SolicitudPersonal(data){
    try{
      var response: any = await this.baseService.add_SolicitudPersonal(data).toPromise();
      console.log(response);
      return response;
    }catch(error){
      console.log(error);
    }    
  }

  async add_Personal(data){
    try{
      var response: any = await this.baseService.add_Personal(data).toPromise();
      console.log(response);
      return response;
    }catch(error){
      console.log(error);
    }    
  }

  validateEmail() {
    var response = false
    var email = this.email; 
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    response = re.test(String(email).toLowerCase());
    this.emailIncorrecto = response ? false : true;
    return response;
  }


  toggleVisibility(show) { 
    this.show = show;
  }

  toggleVisibility2(show) { 
    this.show2 = show;
  }

  backPoll(stepper){
    this.router.navigate(['/iniciar'], { replaceUrl: true });
    stepper.reset()
  }


  formatedRut(rut: any, $event: any) {
    if (rut) {
      var _rut =this.formatRut(rut, $event)
      
      this.getUser(_rut)
      return _rut;
    } else {
      return null;
    }
  }
  
    
  formatRut (texto: any, event: any) {
    if (
      event &&
      event.type != 'blur' &&
      event.code != 'Enter' &&
      event.code != '13' &&
      event.code != 13 &&
      event.charCode != '13' &&
      event.charCode != 13
    )
      return texto;

    if (texto === null || texto === undefined) return null;
    var size = texto.length;
    if (size == 1) return texto;

    //console.log('Antes: ' + texto);
    //si tiene puntos (.) o guiones (-) se los saca
    texto = (texto.slice(0, size - 1).replace(/[^\d]/gi, '') + texto.slice(size - 1).replace(/[^\d^k]/gi, '')).replace(
      /^[0]*/g,
      ''
    );
    //console.log('Después: ' + texto);

    var number = texto.substring(0, texto.length - 1);
    var dv = texto.substring(texto.length - 1);
    //agrega los puntos (.) y el guión (-)
    var rut =
      number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, function($1) {
        return $1 + '.';
      }) +
      '-' +
      dv;
    //console.log(rut);

    return rut;
  }
    
}
